// src/components/PepwiseJoyride/CustomTooltip.tsx
import React from "react";
import { TooltipRenderProps } from "react-joyride";
import {
  Box,
  IconButton,
  Typography,
  Button,
  Stack,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import colors from "assets/theme/base/colors";

interface CustomTooltipProps extends TooltipRenderProps {
  helpersRef?: React.MutableRefObject<any>;
}

const CustomTooltip: React.FC<CustomTooltipProps> = ({
  step,
  index,
  size,
  backProps,
  closeProps,
  primaryProps,
  isLastStep,
  helpersRef,
}) => {
    const handleClose = () => {
        // Safely end the tour
        helpersRef?.current?.close?.();
        helpersRef?.current?.skip?.();
    };
    return (
    <Box
      sx={{
        width: 320,
        backgroundColor: `${colors.tooltip.background.primary}`,
        borderRadius: "4px",
        boxShadow: 4,
        p: 2,
        position: "relative",
      }}
    >
      {/* Close icon */}
      <IconButton
        onClick={handleClose}
        size="small"
        sx={{ position: "absolute", top: 8, right: 8 }}
      >
        <CloseIcon fontSize="small" sx={{color:  `${colors.tooltip.text.primary}`}}/>
      </IconButton>

      {/* Title */}
      <Typography variant="h6" fontWeight={600} mb={0.5} color= {colors.tooltip.text.title}>
        {step.title || "Step " + (index + 1)}
      </Typography>

      {/* Description */}
      <Typography variant="body2" color= {colors.tooltip.text.description} mb={2}>
        {step.content}
      </Typography>

      {/* Progress + Buttons in a single row */}
        <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        mt={2}
        >
        {/* Progress dots */}
        <Stack direction="row" spacing={0.5}>
            {Array.from({ length: size }).map((_, i) => (
            <Box
                key={`joyride-step-dot-${i + 1}`}
                sx={{
                    width: 8,
                    height: 8,
                    borderRadius: "50%",
                    backgroundColor: i === index ? `${colors.tooltip.progressDot.primary}` : `${colors.tooltip.progressDot.secondary}`,
                    transition: "background-color 0.3s",
                }}
            />
            ))}
        </Stack>

        {/* Buttons */}
        <Stack direction="row" spacing={1}>
            {index > 0 && (
            <Button
                {...backProps}
                variant="text"
                sx={{ textTransform: "uppercase", fontSize: 12, color: `${colors.tooltip.button.textSecondary}` }}
            >
                Previous
            </Button>
            )}
            <Button
            {...primaryProps}
            variant="contained"
            sx={{
                textTransform: "uppercase",
                fontSize: 12,
                color: `${colors.tooltip.button.textPrimary}`,
                backgroundColor: `${colors.tooltip.button.BgColor}`,
                "&:hover": { backgroundColor: `${colors.tooltip.button.BgColor}` },
            }}
            >
            {isLastStep ? "Finish" : "Next"}
            </Button>
        </Stack>
        </Stack>
    </Box>
  );
};

export default CustomTooltip;
